import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom, race } from 'rxjs';
import { environment as localEnvironment } from 'src/app/environments/environment.local';
import { SetAccount, SetEnvironment } from 'src/app/shared/actions/environment.actions';
import { EliquaFacadeService } from 'src/app/shared/services/eliqua.facade.service';
import { GetLanguage } from '../../shared/actions/eliqua.actions';
import { GetLiteralsFailed, GetLiteralsSuccess } from '../../shared/actions/literals.actions';
import { GetRoles } from '../../shared/actions/roles.actions';
@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(
    private store: Store,
    private actions$: Actions,
    public facade: EliquaFacadeService,
  ) {}

  init(): Promise<void> {
    const href = window.location.href;
    const hostname = new URL(href).hostname;

    if (href.includes('localhost') || href.includes('uat')) {
      this.facade.dispatch(SetEnvironment({ isProd: false }));
    } else {
      this.facade.dispatch(SetEnvironment({ isProd: true }));
    }

    const account = hostname === 'localhost' ? localEnvironment.clientName : hostname.split('.')[0];
    this.facade.dispatch(SetAccount({ account }));

    this.store.dispatch(GetLanguage());
    this.store.dispatch(GetRoles());

    return firstValueFrom(
      race(this.actions$.pipe(ofType(GetLiteralsSuccess)), this.actions$.pipe(ofType(GetLiteralsFailed))),
    ).then(() => void 0);
  }
}
